// extracted by mini-css-extract-plugin
export var header = "_vf-1";
export var maskBottom = "_vf-6";
export var maskMiddle = "_vf-7";
export var maskTop = "_vf-5";
export var root = "_vf-0";
export var scrollDownButton = "_vf-3";
export var scrollDownButtonHidden = "_vf-4";
export var viewport = "_vf-2";